import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  nurturing: "bg-amber-50 text-amber-700 border-amber-200",
  hired_appointed: "bg-indigo-50 text-indigo-700 border-indigo-200",
  completed: "bg-blue-50 text-blue-700 border-blue-200",
  withdrawn: "bg-slate-100 text-slate-600 border-slate-200",
  terminated: "bg-rose-50 text-rose-700 border-rose-200",
  closed: "bg-slate-100 text-slate-600 border-slate-200",
  inactive: "bg-slate-100 text-slate-600 border-slate-200",
  archived: "bg-slate-100 text-slate-600 border-slate-200",
  disabled: "bg-rose-50 text-rose-700 border-rose-200",
  invited: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  candidate: "bg-teal-50 text-teal-700 border-teal-200",
  producer: "bg-indigo-50 text-indigo-700 border-indigo-200",
  agent: "bg-sky-50 text-sky-700 border-sky-200",
  protege: "bg-violet-50 text-violet-700 border-violet-200",
  agent_staff: "bg-cyan-50 text-cyan-700 border-cyan-200",
  lead: "bg-blue-50 text-blue-700 border-blue-200",
  contact: "bg-slate-50 text-slate-700 border-slate-200",
};

export function StatusBadge({ status, label, className, testId }) {
  const key = (status || "").toLowerCase();
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize",
        MAP[key] || "bg-slate-100 text-slate-600 border-slate-200",
        className
      )}
    >
      {label || (status || "").replace(/_/g, " ")}
    </span>
  );
}
